<script setup lang="ts">
import './style-editor.css'

defineProps<{ html?: string }>()
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <div class="content content-editor" v-html="html" />
</template>
